<template>
  <section>
    <h2 class="text-[22px] text-gray-400 font-black" v-if="partnersTitle">
      Partners
    </h2>
    <ul
      class="grid grid-rows-4 md:grid-rows-2 md:grid-cols-2 lg:grid-rows-1 lg:grid-cols-4 px-2 xl:px-24 my-12 gap-4 lg:gap-0"
    >
      <li class="m-auto">
        <a href="http://terrapirata.com/">
          <picture class="contents">
            <source srcset="/images/download/terrapirata_BLACK_SMOOTH.webp" type="image/webp" />
            <img
            decoding="async"
            fetchpriority="high"
            width="225"
            height="225"
            src="/images/download/terrapirata_BLACK_SMOOTH.png"
            />
          </picture>
        </a>
      </li>
      <li class="m-auto">
        <a href="http://www.rallymotoshop.com/">
          <picture class="contents">
            <source srcset="/images/download/RMSe8c8.webp" type="image/webp" />
            <img
            decoding="async"
            width="225"
            height="225"
            src="/images/download/RMSe8c8.jpg"
            />
          </picture>
        </a>
      </li>
      <li class="m-auto">
        <a href="http://www.icoracing.com/">
          <picture class="contents">
            <source srcset="/images/download/ICO-Rally-MAx703e.webp" type="image/webp" />
            <img
            decoding="async"
            width="225"
            height="225"
            src="/images/download/ICO-Rally-MAx703e.jpg"
            />
          </picture>
        </a>
      </li>
      <li class="m-auto">
        <a href="http://jimmylewisoffroad.com/">
          <picture class="contents">
            <source srcset="/images/download/Jimmy-Lewis-Logof697.webp" type="image/webp" />
            <img
            decoding="async"
            loading="lazy"
            width="225"
            height="225"
            src="/images/download/Jimmy-Lewis-Logof697.png"
            />
          </picture>
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'PartnersSmall',
  props: {
    partnersTitle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
